import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import UserFooter from '../components/UserFooter';
import '../styles/LegalPages.css';

const PrivacyPolicy = () => {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="legal-page">
      {/* Header */}
      <header className="legal-header">
        <button className="legal-back-btn" onClick={() => navigate(-1)}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M15 18L9 12L15 6" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </button>
        <img
          src="/assets/images/logo2.png"
          alt="LegacyStat"
          className="legal-logo"
          onClick={() => navigate('/')}
          style={{ cursor: 'pointer' }}
        />
        <div style={{ width: '24px' }}></div>
      </header>

      {/* Content */}
      <div className="legal-content">
        <div className="legal-container">
          <h1 className="legal-title">Privacy Policy</h1>
          <p className="legal-updated">Last Updated: February 2026</p>

          <section className="legal-section">
            <h2>Introduction</h2>
            <p>LegacyStat ("we," "our," "us") operates the LegacyStat Spotlight website (the "Service"). This Privacy Policy explains how we collect, use, and protect information submitted by users, parents, coaches, and athletes.</p>
          </section>

          <section className="legal-section">
            <h2>1. Information We Collect</h2>
            <h3>Information You Provide:</h3>
            <ul>
              <li>Athlete name, sport, team, and league</li>
              <li>Photos, videos, and other media</li>
              <li>Spotlight descriptions and submission notes</li>
              <li>Parent/coach contact information (name, phone, email)</li>
            </ul>

            <h3>Automatically Collected Information:</h3>
            <ul>
              <li>Device type and browser type</li>
              <li>IP address</li>
              <li>Basic usage data needed to operate the Service</li>
            </ul>

            <h3>Media Storage:</h3>
            <p>Uploaded images and videos are stored securely through third-party providers.</p>
          </section>

          <section className="legal-section">
            <h2>2. How We Use Information</h2>
            <p>We use collected information to:</p>
            <ul>
              <li>Create and publish athlete Spotlights</li>
              <li>Display Spotlight images, captions, and athlete details</li>
              <li>Manage submissions and prevent inappropriate content</li>
              <li>Improve site performance and reliability</li>
              <li>Communicate with submitters when needed</li>
            </ul>
            <p><strong>We do not sell personal information.</strong></p>
          </section>

          <section className="legal-section">
            <h2>3. Children's Privacy</h2>
            <p>All submissions must be completed by an adult (parent, guardian, or coach). We do not knowingly collect information directly from minors.</p>
          </section>

          <section className="legal-section">
            <h2>4. Sharing of Information</h2>
            <p>We may share data only with:</p>
            <ul>
              <li>Service providers essential for operating the site</li>
              <li>Law enforcement if legally required</li>
              <li>Leagues or organizations when requested by the submitting adult</li>
            </ul>
            <p><strong>We do not share data for advertising or marketing.</strong></p>
          </section>

          <section className="legal-section">
            <h2>5. Removal Requests</h2>
            <p>Parents, guardians, or athletes may request removal of Spotlight pages, photos, videos, or personal information.</p>
            <p>Contact: <a href="mailto:support@legacystat.com" className="legal-link">support@legacystat.com</a></p>
          </section>

          <section className="legal-section">
            <h2>6. Data Security</h2>
            <p>We use reasonable measures to protect information but cannot guarantee absolute security.</p>
          </section>

          <section className="legal-section">
            <h2>7. Changes to This Policy</h2>
            <p>Updates may occur periodically. Continued use of the Service indicates acceptance.</p>
          </section>

          <section className="legal-section">
            <h2>8. Contact</h2>
            <p>Questions: <a href="mailto:support@legacystat.com" className="legal-link">support@legacystat.com</a></p>
          </section>
        </div>
      </div>

      <UserFooter />
    </div>
  );
};

export default PrivacyPolicy;
